import React, { FormEvent, useEffect, useState } from 'react';
import "./panier_visiteur.css";
import axios from 'axios';
import { NavLink, useNavigate } from 'react-router-dom';
import PanierLengVisiteur from '../../../Services/Panier/PanierLeng';
import Timer from '../../../components/Timer';
import AfficheMagasinsService from '../../../Services/Magasin/AfficheMagasinsService';
import { MagasinInfo } from '../../../Modeles/MagasinModel';
import OverlayLoader from '../../../components/OverlayLoader';

interface Product {
  IdArticle: any;
  name: string;
  image: string;
  prix: number;
  Reference: any;
  quantity: number;
  NomMagasin: any;
}

interface SocieteLivraison {
  id: number;
  NomSociete: string;
  AdresseSociete: string;
  Prix: string;
  Status: string;
  Date: string;
}

export default function ModernPanier() {
  const handleGoBack = () => window.history.back();

  const [products, setProducts]       = useState<Product[]>([]);
  const [isDivVisible, setDivVisible] = useState(true);
  const [Totale, setTotale]           = useState<number>(0);
  const [message, setMessage]         = useState('');
  const [PanierLen, setPanierLen]     = useState<any[]>([]);
  const [loading, setLoadings]        = useState(false);
  const [showSuccessPopup]            = useState(false);
  const [submitting, setSubmitting]   = useState(false);
  const [orderProgressMessage, setOrderProgressMessage] = useState<string>("Enregistrement de la commande...");
  const [deletingId, setDeletingId]   = useState<any>(null);
  const [clearingCart, setClearingCart] = useState(false);

  // ── Delivery state ─────────────────────────────────────────────
  const [deliveryType, setDeliveryType]       = useState<'societe' | 'magasin'>('societe');
  const [magasins, setMagasins]               = useState<MagasinInfo[]>([]);
  const [selectedMagasin, setSelectedMagasin] = useState<MagasinInfo | null>(null);
  const [societes, setSocietes]               = useState<SocieteLivraison[]>([]);
  const [selectedSociete, setSelectedSociete] = useState<SocieteLivraison | null>(null);
  // ──────────────────────────────────────────────────────────────

  const visiteurId      = localStorage.getItem('VisiteurId') ?? '';
  const visiteurName    = localStorage.getItem('VisiteurName');
  const VisiteurAdresse = localStorage.getItem('VisiteurAdresse') ?? '';
  const navigate        = useNavigate();
  const expireTime      = Date.now() + 24 * 60 * 60 * 1000;

  const fraisSociete = selectedSociete && deliveryType === 'societe' ? (selectedSociete.Prix === '-' ? 0 : parseFloat(selectedSociete.Prix || '0')) : 0;
  const fraisLivraison = deliveryType === 'societe' ? fraisSociete : 100;
  const totalAvecFrais = parseFloat((Totale + fraisLivraison).toFixed(2));

  // ── 1. Load localStorage products ─────────────────────────────
  useEffect(() => {
    const stored = localStorage.getItem('productVisiteur');
    if (stored) {
      try { setProducts(JSON.parse(stored)); }
      catch (e) { console.error(e); }
    }
  }, []);

  // ── 2. Load magasins from backend ─────────────────────────────
useEffect(() => {
  setLoadings(true);

  AfficheMagasinsService()
    .getMagasin()
    .then((res) => {
      const rawList: MagasinInfo[] = res.data;

      // filter magasins where ReceptionClois = 1
      const filteredList = rawList.filter(
        (magasin) => magasin.ReceptionClois === 1
      );

      setMagasins(filteredList);

      if (filteredList.length > 0) {
        setSelectedMagasin(filteredList[0]);
      }
    })
    .catch((err) => console.error('Erreur chargement magasins:', err))
    .finally(() => setLoadings(false));
}, []);

  // ── 2b. Load sociétés de livraison ────────────────────────────
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/societe-livraison`)
      .then(({ data }) => {
        const activeSocietes = data.filter((s: SocieteLivraison) => s.Status === 'active');
        setSocietes(activeSocietes);
        if (activeSocietes.length > 0) {
          setSelectedSociete(activeSocietes[0]);
        }
      })
      .catch((err) => console.error('Erreur chargement sociétés:', err));
  }, []);
  const Type = "Visiteurs";

  // ── 3. Load panier ─────────────────────────────────────────────
  useEffect(() => {
    setLoadings(true);
    PanierLengVisiteur(visiteurId, Type)
      .GetLenPanier()
      .then((response: any) => setPanierLen(response.data))
      .catch((error: any) => console.error('Error fetching panier:', error))
      .finally(() => setLoadings(false));
  }, []);

  useEffect(() => { sumQty(); }, [PanierLen]);

  // ── Helpers ────────────────────────────────────────────────────
  const sumQty = () => {
    let total = 0;
    for (const item of PanierLen) {
      total += Number(item.price.toString().replace(',', '.')) * Number(item.quantity);
    }
    const rounded = parseFloat(total.toFixed(2));
    setTotale(rounded);
    return rounded;
  };

  const handleDeleteProduct = async (id: any, e: React.FormEvent) => {
    e.preventDefault();
    setDeletingId(id);
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier/delete`, { id });
      const newPanier = PanierLen.filter((item: any) => item.id !== id);
      setPanierLen(newPanier);
      if (newPanier.length === 0) {
        setMessage('Votre panier est vide !');
        setTimeout(() => { setMessage(''); setDivVisible(true); }, 3000);
        localStorage.removeItem('cartExpiration');
        localStorage.removeItem('productVisiteur');
        window.dispatchEvent(new Event('panier-updated'));
      }
    } catch (err) {
      console.log(err);
    } finally {
      setDeletingId(null);
    }
  };

  const handleVidePanier = async (e: React.FormEvent) => {
    e.preventDefault();
    setClearingCart(true);
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier/delete/all/${visiteurId}`);
      setPanierLen([]);
      // ⏱ Clear the frontend timer immediately
      localStorage.removeItem('cartExpiration');
      localStorage.removeItem('productVisiteur');
      window.dispatchEvent(new Event('panier-updated'));
    } catch (err) {
      console.log(err);
    } finally {
      setClearingCart(false);
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!deliveryType) return;
    if (deliveryType === 'magasin' && !selectedMagasin) return;
    if (deliveryType === 'societe' && !selectedSociete) return;
    if (PanierLen.length === 0) return;

    setSubmitting(true);
    setDivVisible(false);

    try {
      // Group items by seller so each seller gets a distinct order, exactly like PanierMagasin
      const grouped = PanierLen.reduce<Record<string, any[]>>((acc, item) => {
        const key = (item.NomMagasin || "").trim() || "Inconnu";
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      const sellerKeys = Object.keys(grouped);
      const totalOrdersCount = sellerKeys.length;
      let lastCommandeId = "";

      for (let i = 0; i < totalOrdersCount; i++) {
        const sellerName = sellerKeys[i];
        const subItems = grouped[sellerName];
        const orderIndexLabel = totalOrdersCount > 1 ? `[${i + 1}/${totalOrdersCount}] ` : "";
        const subTotal = subItems.reduce(
          (acc, it) => acc + Number(String(it.price).replace(',', '.')) * Number(it.quantity),
          0
        );
        const subFrais = i === 0 ? fraisLivraison : 0;
        const subTotalTTC = parseFloat((subTotal + subFrais).toFixed(2));

        const formData = new FormData();
        formData.append('adress',         VisiteurAdresse);
        formData.append('NomClient',      visiteurName ? visiteurName : "");
        formData.append('SousClient',     visiteurId);
        formData.append('IdMagasin',      visiteurId);
        formData.append('Remarque',       '');
        formData.append('TotalHT',        subTotal.toString());
        formData.append('TotalTTC',       subTotalTTC.toString());
        formData.append('FraisLivraison', subFrais.toString());
        formData.append('ModeLivraison',  deliveryType);

        formData.append(
          'MagasinRetrait',
          deliveryType === 'magasin' && selectedMagasin
            ? `${selectedMagasin.NomMagasin}`
            : selectedSociete ? selectedSociete.NomSociete : 'Société de livraison'
        );
        formData.append(
          'AdresseRetreit',
          deliveryType === 'magasin' && selectedMagasin
            ? `${selectedMagasin.adresse_de_siege}`
            : selectedSociete ? selectedSociete.AdresseSociete : 'a la société'
        );
        formData.append('NomMagasin',       sellerName);
        formData.append('TypeUtilisateur',  'visiteur');
        formData.append('MethodPayment',    'sans');
        formData.append('StatutPayment',    'Non paye');
        formData.append(
          'SocieteLivraison',
          deliveryType === 'societe' && selectedSociete ? selectedSociete.NomSociete : ''
        );

        subItems.forEach((item: any, index: number) => {
          formData.append(`detail[${index}][IdArticle]`,   String(item.IdArticle));
          formData.append(`detail[${index}][designation]`, String(item.Designation));
          formData.append(`detail[${index}][vendeur]`,     String(item.NomMagasin));
          formData.append(`detail[${index}][refArticle]`,  String(item.RefArticle));
          formData.append(`detail[${index}][quantity]`,    String(item.quantity));
          formData.append(`detail[${index}][prix]`,        String(item.price));
        });

        // 1️⃣ Première fonction : Enregistrer la commande
        setOrderProgressMessage(
          totalOrdersCount > 1
            ? `${orderIndexLabel}Enregistrement de la commande pour "${sellerName}"...`
            : `Enregistrement de la commande...`
        );
        const response = await axios.post(
          `${process.env.REACT_APP_PHP_APP_URL}/enregistrerCommande`,
          formData
        );
        const commandeId = response.data.IdCom;
        const IDBL       = response.data.IdBl;
        lastCommandeId   = commandeId;

        // 2️⃣ Deuxième fonction : Envoyer les articles liés à la commande
        setOrderProgressMessage(
          totalOrdersCount > 1
            ? `${orderIndexLabel}Envoi des ${subItems.length} articles pour "${sellerName}" (BL : ${IDBL})...`
            : `Envoi des ${subItems.length} articles (BL : ${IDBL})...`
        );
        await axios.post(
          `${process.env.REACT_APP_PHP_APP_URL}/sendArticleCommande/${IDBL}`,
          { DataTable: subItems },
          { headers: { 'Content-Type': 'application/json' } }
        );
      }

      // 3️⃣ Finalisation et vidage du panier
      setOrderProgressMessage("Finalisation et vidage du panier...");
      try {
        await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier/delete/all/${visiteurId}`);
      } catch (delErr) {
        console.error("Erreur vidage panier:", delErr);
        const panierId = PanierLen.map((item: any) => item.id).join(',');
        if (panierId) {
          try {
            await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier/delete`, { id: panierId });
          } catch (e) {
            console.error(e);
          }
        }
      }

      if (lastCommandeId) {
        localStorage.setItem('CommandeId', lastCommandeId.toString());
        localStorage.setItem('Expire',     expireTime.toString());
      }
      localStorage.removeItem('cartExpiration');
      localStorage.removeItem('productVisiteur');
      window.dispatchEvent(new Event('panier-updated'));

      setMessage('Votre commande a été envoyée avec succès !');
      setTimeout(() => { setMessage(''); setDivVisible(true); }, 3000);
      navigate('/visiteurs/panier/continue');

    } catch (error) {
      console.error("Erreur lors de l'envoi de la commande:", error);
      setMessage("Une erreur est survenue lors de l'enregistrement de la commande");
      setTimeout(() => setMessage(''), 4000);
    } finally {
      setSubmitting(false);
    }
  };

  // ── JSX ────────────────────────────────────────────────────────
  return (
    <div className="modern-panier">
      <div className="panier-header">
        <div className="brand-title">
          <h1>Wyn</h1>
          <div className="title-underline"></div>
        </div>
      </div>

      <div className="panier-container">

        {showSuccessPopup && (
          <div className="popup-success">
            <div className="popup-content">
              <div className="popup-icon">
                <i className="bi bi-check-circle-fill"></i>
              </div>
              <h5>Commande envoyée avec succès !</h5>
              <p>Vous serez contacté dans les plus brefs délais</p>
            </div>
          </div>
        )}

        {/* ────────────── Products ────────────── */}
        <div className="products-section">
          <NavLink to={''} className="retour-icon">
            <i onClick={handleGoBack} className="bi bi-arrow-left-circle-fill"></i>
          </NavLink>

          <div className="section-header">
            <div className="cart-icon">
              <i className="bi bi-arrow-left" style={{cursor:"pointer"}} onClick={() => window.history.back()}></i>
            </div>
            <h2>Votre panier</h2>
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '550px', color: '#FFC400' }}>
              <div className="spinner-border" role="status" />
            </div>
          ) : !isDivVisible && message ? (
            <div className="success-message">
              <div className="success-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <p>{message}</p>
            </div>
          ) : (
            <div className="products-list">
              {PanierLen.length === 0 ? (
                <div className="empty-cart">
                  <div className="empty-icon">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3 3H5L5.4 5M7 13H17L21 5H5.4M7 13L5.4 5M7 13L4.7 15.3C4.3 15.7 4.6 16.5 5.1 16.5H17"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <p>Votre panier est vide</p>
                </div>
              ) : (
                PanierLen.map((item: any, index: number) => (
                  <div key={index} className="product-card-panier">
                    <div className="product-image-panier">
                      <img src={item.Image || ''} alt={item.Designation} />
                    </div>
                    <div className="product-info">
                      <h3 className="product-name">{item.Designation}</h3>
                      <div className="product-details">
                        <span className="product-price">{item.price} MAD</span>
                        <span className="product-ref">Réf: {item.RefArticle}</span>
                      </div>
                    </div>
                    <div className="quantity-section">
                      <label>Quantité</label>
                      <div className="quantity-input">
                        <input type="number" value={item.quantity} readOnly min={1} />
                      </div>
                    </div>
                    <div className="total-price">
                      {(Number(item.price.toString().replace(',', '.')) * Number(item.quantity)).toFixed(2)} MAD
                    </div>
                    <button onClick={(e) => handleDeleteProduct(item.id, e)} className="delete-btn" disabled={deletingId === item.id}>
                      {deletingId === item.id ? (
                        <span style={{display:'inline-block',width:16,height:16,border:'2.5px solid rgba(0,0,0,0.15)',borderTopColor:'#FFC400',borderRadius:'50%',animation:'spin 0.65s linear infinite'}} />
                      ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M3 6H5H21M8 6V4A2 2 0 0 1 10 2H14A2 2 0 0 1 16 4V6M19 6V20A2 2 0 0 1 17 22H7A2 2 0 0 1 5 20V6H19Z"
                          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        />
                        <path d="M10 11V17M14 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      )}
                    </button>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        {/* ────────────── Summary ─────────────── */}
        <div className="summary-section">
      <Timer />

          <div className="summary-card">
            <h3>Récapitulatif de commande</h3>

            <div className="summary-lines">
              <div className="summary-line">
                <span>Sous-total</span>
                <span>{Totale.toFixed(2)} MAD</span>
              </div>
              <div className="summary-line">
                <span>Remise</span>
                <span>0 MAD</span>
              </div>
            </div>

            {/* ── Delivery picker ── */}
            <div className="delivery-picker">
              <p className="delivery-picker__label">Mode de livraison</p>
              <div className="delivery-picker__options">

                <div
                  className={`delivery-option ${deliveryType === 'societe' ? 'delivery-option--active' : ''}`}
                  onClick={() => setDeliveryType('societe')}
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="1" y="3" width="15" height="13"/>
                    <path d="M16 8h4l3 5v3h-7z"/>
                    <circle cx="5.5" cy="18.5" r="2.5"/>
                    <circle cx="18.5" cy="18.5" r="2.5"/>
                  </svg>
                  <span>Société de livraison</span>
                </div>

                <div
                  className={`delivery-option ${deliveryType === 'magasin' ? 'delivery-option--active' : ''}`}
                  onClick={() => setDeliveryType('magasin')}
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
                    <polyline points="9 22 9 12 15 12 15 22"/>
                  </svg>
                  <span>Retrait en magasin</span>
                </div>
              </div>

              {/* Société de livraison list */}
              {deliveryType === 'societe' && (
                <div className="magasin-list">
                  <p className="magasin-list__hint">Sélectionnez la société de livraison :</p>

                  {societes.length === 0 ? (
                    <div className="magasin-empty">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="1" y="3" width="15" height="13"/>
                        <path d="M16 8h4l3 5v3h-7z"/>
                        <circle cx="5.5" cy="18.5" r="2.5"/>
                        <circle cx="18.5" cy="18.5" r="2.5"/>
                      </svg>
                      <p>Aucune société de livraison disponible</p>
                    </div>
                  ) : (
                    societes.map((soc) => (
                      <div
                        key={soc.id}
                        className={[
                          'magasin-item',
                          selectedSociete?.id === soc.id ? 'magasin-item--selected' : '',
                        ].filter(Boolean).join(' ')}
                        onClick={() => setSelectedSociete(soc)}
                      >
                        <div className={`magasin-radio ${selectedSociete?.id === soc.id ? 'magasin-radio--checked' : ''}`} />
                        <div className="magasin-info">
                          <div className="magasin-name-nup">
                            <i className="bi bi-truck" style={{ color: '#9aad00', marginRight: 4 }}></i>
                            {soc.NomSociete}
                          </div>
                          <div className="magasin-addr"><i className="bi bi-geo-alt-fill"></i> {soc.AdresseSociete}</div>
                          <div className="magasin-dist">{soc.Prix === '-' || parseFloat(soc.Prix || '0') === 0 ? "- MAD" : `${parseFloat(soc.Prix).toFixed(2)} MAD`}</div>
                        </div>
                      </div>
                    ))
                  )}

                  <div className="delivery-info-banner delivery-info-banner--blue">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="12" y1="8" x2="12" y2="12"/>
                      <line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    Livraison à domicile — frais de livraison selon la société sélectionnée.
                  </div>
                </div>
              )}

              {/* Magasin list */}
              {deliveryType === 'magasin' && (
                <div className="magasin-list">
                  <p className="magasin-list__hint">Sélectionnez le magasin de retrait :</p>

                  {magasins.length === 0 ? (
                    <div className="magasin-empty">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
                        <polyline points="9 22 9 12 15 12 15 22"/>
                      </svg>
                      <p>Aucun magasin disponible</p>
                    </div>
                  ) : (
                    magasins.map((mag) => (
                      <div
                        key={mag.IdMagasin}
                        className={[
                          'magasin-item',
                          selectedMagasin?.IdMagasin === mag.IdMagasin ? 'magasin-item--selected' : '',
                        ].filter(Boolean).join(' ')}
                        onClick={() => setSelectedMagasin(mag)}
                      >
                        <div className={`magasin-radio ${selectedMagasin?.IdMagasin === mag.IdMagasin ? 'magasin-radio--checked' : ''}`} />
                        <div className="magasin-info">
                          <div className="magasin-addr"><i className="bi bi-geo-alt-fill"></i> {mag.adresse_de_siege}</div>
                          <div className="magasin-name-nup">magasin {mag.NomMagasin}</div>
                        </div>
                      </div>
                    ))
                  )}

                  <div className="delivery-info-banner delivery-info-banner--green">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="12" y1="8" x2="12" y2="12"/>
                      <line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    Frais de préparation de 1% appliqués.
                  </div>
                </div>
              )}
            </div>

            <div className="summary-divider"></div>

            <div className="summary-lines">
              <div className="summary-line summary-line--frais">
                <span>{deliveryType === 'societe' && selectedSociete ? `Frais — ${selectedSociete.NomSociete}` : 'Frais de livraison (1%)'}</span>
                <span>{fraisLivraison === 0 ? "- MAD" : `${fraisLivraison.toFixed(2)} MAD`}</span>
              </div>
              <div className="summary-line total-line">
                <span>Total</span>
                <span>{totalAvecFrais.toFixed(2)} MAD</span>
              </div>
            </div>

            <div className="action-buttons">
              <button
                onClick={handleSubmit}
                className="validate-btn"
                disabled={
                  submitting ||
                  PanierLen.length === 0 ||
                  !deliveryType ||
                  (deliveryType === 'magasin' && !selectedMagasin) ||
                  (deliveryType === 'societe' && !selectedSociete)
                }
              >
                {submitting ? (
                  <><span style={{display:'inline-block',width:16,height:16,border:'2.5px solid rgba(255,255,255,0.3)',borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.65s linear infinite'}} /> Envoi en cours...</>
                ) : (
                  <>Confirmer la commande
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                </svg></>
                )}
              </button>

              <button
                className="clear-btn"
                onClick={handleVidePanier}
                disabled={PanierLen.length === 0 || clearingCart}
              >
                {clearingCart ? (
                  <><span style={{display:'inline-block',width:16,height:16,border:'2.5px solid rgba(0,0,0,0.15)',borderTopColor:'currentColor',borderRadius:'50%',animation:'spin 0.65s linear infinite'}} /> Vidage...</>
                ) : (
                  <><svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M3 6H5H21M8 6V4A2 2 0 0 1 10 2H14A2 2 0 0 1 16 4V6M19 6V20A2 2 0 0 1 17 22H7A2 2 0 0 1 5 20V6H19Z"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                  />
                </svg>
                Vider le panier</>
                )}
              </button>
            </div>
          </div>
        </div>

      </div>

      {/* Overlay Loader */}
      {submitting && <OverlayLoader message={orderProgressMessage} />}
    </div>
  );
}